import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { IstActivitiesSeminarsViewModalComponent } from './ist-activities-seminars-view-modal/ist-activities-seminars-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';
@Component({
  selector: 'app-ist-activities-seminars',
  templateUrl: './ist-activities-seminars.component.html',
  styleUrls: ['./ist-activities-seminars.component.scss']
})
export class IstActivitiesSeminarsComponent implements OnInit {

  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  activitiesandseminars: UntypedFormGroup;
  collapesedOrNot: Boolean = false;
  permission: string = "";
  userType: string = "";
  staticformFields: any;
  typeOptions = [];
  minDate:Date;
  screenName:string='';

  constructor(
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe,
  ) {
  }

  ngOnInit() {

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    
    this.activitiesandseminars = new UntypedFormGroup({
      ActivityType: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      StartDateO: new UntypedFormControl(null),
      EndDateO: new UntypedFormControl(null),

    });


    this.permission = this.commonService.getPagePermission("IST10").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == ''){
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("IST10").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.setSummary();
           clearInterval(intervalId);
         }
       }, 1000);
    }
    else{
        this.setSummary();
    }

    this.getStaticFiledsData('SCR-010');
    this.GetScreenConfigControls('SCR-010');
    this.userType = this.userService.getUserType(); 
    this.GetMasterDropData();
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode,this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if (this.userType == "E"){
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.TYPE.LABEL_NAME,
              "field": "ActivityType"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title"
            },
            {
              "headerName": this.staticformFields?.START_DATE.LABEL_NAME,
              "field": "StartDateStr"
            },
            {
              "headerName": this.staticformFields?.END_DATE.LABEL_NAME,
              "field": "EndDateStr"
            },
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr"
            },
            {
              "headerName": "Status",
              "field": "Status"
            }
          ];
        } else{
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.TYPE.LABEL_NAME,
              "field": "ActivityType"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title"
            },
            {
              "headerName": this.staticformFields?.START_DATE.LABEL_NAME,
              "field": "StartDateStr"
            },
            {
              "headerName": this.staticformFields?.END_DATE.LABEL_NAME,
              "field": "EndDateStr"
            },
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr"
            }
          ];

          if(this.staticformFields?.START_DATE.IS_PASTDATES_ALLOWED)
          {
            this.minDate = new Date();
          }
          if(this.staticformFields?.END_DATE.IS_PASTDATES_ALLOWED){
              this.minDate = new Date();
          }

        }
      });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    let modalRef =this['self'].modalService.open(IstActivitiesSeminarsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add() {
    let modalRef = this.modalService.open(IstActivitiesSeminarsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.setSummary();
    })
  }

  edit(RcordData:any) {
    let modalRef = this['self'].modalService.open(IstActivitiesSeminarsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content= {
        heading: "Edit",
        content: { id: RcordData['ID'], ApplicationID: this.ApplicationID }

      }
   
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }


  delete(RcordData:any) {
    let id = RcordData['ID'];
    let name = RcordData['Title'];
    let modalRef  = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content={ heading: 'Delete Activity and Seminar',  custommessage: 'Are you sure you want to delete '  +' ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"};

    modalRef.result.then(result => {
      if(result == "okclick"){
        this['self'].summaryService.DeleteRecord('api/ISTActivitiesseminars/Delete?RecordID=' + id).subscribe(summary => {
          if (summary["Status"] == 0) {
            this['self'].commonService.SuccessBanner(this['self'].screenName + ' deleted successfully')
            this['self'].setSummary();
          }
          else {
            this.commonService.ValidationBanner("Selected Record(s) has not been Deleted");
            //toastrService.error("Selected Record(s) has been Deleted");
          }
        });
      }      
    })

  }

  view(RcordData:any) {
    let modalRef = this['self'].modalService.open(IstActivitiesSeminarsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content= {
        heading: "View",
        content: { id: RcordData['ID'], ApplicationID: this.ApplicationID }

      }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  setSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTActivitiesseminars/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    this.tempoperations = [];
    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add Activity and Seminar",
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add Activity and Seminar",
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }   
    });

    setTimeout(()=>{
      this.gridApi.sizeColumnsToFit();
      },500);
    return RawData;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  getSearchSummary(searchObject) {
    this.summaryService.fetchSearchData("api/ISTActivitiesseminars/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }
  SearchClear() {
    this.activitiesandseminars.reset();
  }
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }


  AdvanceSearch() {
    var formData = this.activitiesandseminars.value;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["StartDate"] != null && formData["StartDate"] != undefined) {
      formData["StartDate"] = new Date(formData["StartDate"]);
      formData['StartDateStr'] = this.datepipe.transform(formData["StartDate"], 'dd-MMM-yyyy');
      formData["StartDateO"] = this.Full_Start_Date;
    }
    if (formData["EndDate"] != null && formData["EndDate"] != undefined) {
      formData["EndDate"] = new Date(formData["EndDate"]);
      formData['EndDateStr'] = this.datepipe.transform(formData["EndDate"], 'dd-MMM-yyyy');
      formData["EndDateO"] = this.Full_End_Date;
    }

    let type = this.typeOptions.find(x=> x.value == formData["ActivityType"]);  
      
    if(formData["ActivityType"] == null)
    {
      formData["ActivityType"] = "";
    } else{
      formData["ActivityType"] = type.label;
    }
    this.getSearchSummary(formData);
  }

  GetMasterDropData() {
    this.summaryService.getScreenDataForEdit("api/ISTActivitiesseminars/GetMasterDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + "").subscribe(result => {
      this.typeOptions = result["MasterData3"];
      this.typeOptions = [{ label: "All", value: null, checked: true }].concat(this.typeOptions);
    });
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, '',(ScreenData) => {
      this.screenName= ScreenData.NAME;
    });
  }

}
